import { StackIcon as PhosphorStackIcon } from "@phosphor-icons/react/dist/ssr/Stack";

import { createAppIcon } from "@/components/createAppIcon";

export const FeedIcon = /* @__PURE__ */ createAppIcon(PhosphorStackIcon);
export const FeedFilledIcon = /* @__PURE__ */ createAppIcon(PhosphorStackIcon, "fill");
